import { useCreateOrder } from '@contexts/OrderContext/useCreateOrder'
import { CartContentProvider } from '@segments/Cart'
import * as React from 'react'

type TProps = RequiredChildren

/**
 * CartContentProvider on MenuScreen,
 * that also ensures an order is loaded from the persistence (is stored)
 * or new one is created for the cart.
 */
export const MenuCartContentProvider: React.FC<TProps> = ({ children }) => {
  const orderId = useCreateOrder()

  return <CartContentProvider orderId={orderId}>{children}</CartContentProvider>
}
